var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"catalog"},_vm._l((_vm.catalog),function(item,index){return _c('cata-item',{key:index,attrs:{"cata":item}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }